var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('div',{staticClass:"wrapper"},[_c('h1',[_vm._v("404 Not Found")]),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.backToHome}},[_vm._v("Back to Home")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }